import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout.vue'

Vue.use(Router)

/*
  redirect:                      if `redirect: noredirect`, it won't redirect if click on the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export default new Router({
  // mode: 'history',  // Disabled due to Github Pages doesn't support this, enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login/Login.vue'),
      meta: { hidden: true },
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: () => import(/* webpackChunkName: "reset-password" */ '@/views/login/ResetPassword.vue'),
      meta: { hidden: true },
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { hidden: true },
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      name: 'Dashboard',
      meta: { hidden: true },
      children: [
        {
          path: 'dashboard',
          name: 'Home',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
        },
        {
          path: '/account-info',
          name: 'AccountInfo',
          component: () => import(/* webpackChunkName: "account-info" */ '@/views/account/AccountInfo.vue'),
          meta: { hidden: true, title: '账号信息' },
        },
        {
          path: '/conf-setting',
          name: 'Confsetting',
          component: () => import(/* webpackChunkName: "account-info" */ '@/views/confsetting/Confsetting.vue'),
          meta: { hidden: true, title: '系统设置' },
        },
        {
          path: '/conf-setting-DP',
          name: 'ConfsettingDP',
          component: () => import(/* webpackChunkName: "account-info" */ '@/views/confsetting/AccountInfo.vue'),
          meta: { hidden: true, title: '大屏设置' },
        },
      ],
    },
    // {
    //   path: '/example',
    //   component: Layout,
    //   redirect: '/example/table',
    //   name: 'Example',
    //   meta: { title: 'Example', icon: 'example' },
    //   children: [
    //     {
    //       path: 'table',
    //       name: 'Table',
    //       component: () => import(/* webpackChunkName: "table" */ '@/views/table/index.vue'),
    //       meta: { title: 'Table', icon: 'table' },
    //     },
    //     {
    //       path: 'tree',
    //       name: 'Tree',
    //       component: () => import(/* webpackChunkName: "tree" */ '@/views/tree/index.vue'),
    //       meta: { title: 'Tree', icon: 'tree' },
    //     },
    //   ],
    // },
    /** ------------------------------数据统计------------------------------------- */
    {
      path: '/stats',
      component: Layout,
      redirect: '/stats/data',
      name: 'Stats',
      meta: { title: '数据统计', icon: 'shangjiashujutongji' },
      children: [
        {
          path: 'data',
          name: 'StatsData',
          component: () => import(/* webpackChunkName: "stats-data" */ '@/views/stats/StatsData.vue'),
          meta: { title: '数据统计', icon: '' },
        },
        {
          path: 'unit',
          name: 'StatsUnit',
          component: () => import(/* webpackChunkName: "stats-unit" */ '@/views/stats/StatsUnit.vue'),
          meta: { title: '单元分析', icon: '' },
        },
        {
          path: 'excaption',
          name: 'StatsExcaption',
          component: () => import(/* webpackChunkName: "stats-excaption" */ '@/views/stats/StatsExcaption.vue'),
          meta: { title: '异常统计', icon: '' },
        },
        {
          path: 'electric',
          name: 'StatsElectric',
          component: () => import(/* webpackChunkName: "stats-excel" */ '@/views/stats/StatsElectric.vue'),
          meta: { title: '电量统计', icon: '' },
        },
        // {
        //   path: 'excel',
        //   name: 'StatsExcel',
        //   component: () => import(/* webpackChunkName: "stats-excel" */ '@/views/stats/StatsExcel.vue'),
        //   meta: { title: '统计报表', icon: '' },
        // },
      ],
    },
    /** ------------------------------部门管理------------------------------------- */
    {
      path: '/department',
      component: Layout,
      redirect: '/department/list',
      name: 'Department',
      meta: { title: '部门管理', icon: 'bumen' },
      children: [
        {
          path: 'list',
          name: 'DepartmentList',
          component: () => import(/* webpackChunkName: "department-list" */ '@/views/department/DepartmentList.vue'),
          meta: { title: '部门管理', icon: 'bumen' },
        },
      ],
    },
    /** ------------------------------用户管理------------------------------------- */
    {
      path: '/user',
      component: Layout,
      redirect: '/user/list',
      name: 'User',
      meta: { title: '用户管理', icon: 'user' },
      children: [
        {
          path: 'list',
          name: 'UserList',
          component: () => import(/* webpackChunkName: "user-list" */ '@/views/user/UserList.vue'),
          meta: { title: '用户管理', icon: 'user' },
        },
      ],
    },
    /** ------------------------------设备管理------------------------------------- */
    {
      path: '/dev',
      component: Layout,
      redirect: '/dev/list',
      name: 'Dev',
      meta: { title: '设备管理', icon: 'user' },
      children: [
        {
          path: 'list',
          name: 'UserList',
          component: () => import(/* webpackChunkName: "user-list" */ '@/views/dev/devList.vue'),
          meta: { title: '设备管理', icon: 'example' },
        },
      ],
    },
    // {
    //   path: 'external-link',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'https://github.com/Armour/vue-typescript-admin-template',
    //       meta: { title: 'External Link', icon: 'link' },
    //     },
    //   ],
    // },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true },
    },
  ],
})
